import { render, staticRenderFns } from "./CirculationInfo.vue?vue&type=template&id=190be080&scoped=true&"
import script from "./CirculationInfo.vue?vue&type=script&lang=js&"
export * from "./CirculationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CirculationInfo.vue?vue&type=style&index=0&id=190be080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190be080",
  null
  
)

export default component.exports